module.exports = __webpack_public_path__ + "static/media/unfortunate_events_myway.47ee2d2e.svg";